<template>
  <router-view/>
</template>

<script>
  export default {
    name: 'Ticket',
  }
</script>

<style scoped>
</style>